import { applyHead } from "@app/config/applyHead"
import { BLOCKED_FOR_CRYPTO_COUNTRY } from "@app/config/countriesWithCryptoBlock"
import { getAppConfig } from "@app/config/getAppConfig"
import initThirdParties from "@app/libs/initThirdParties"
import {
    cloudfrontMetaInformation,
    CLOUD_FRONT_HEADERS,
} from "@shared/api/site-api/cloudfront-meta-information"
import { useAppModeStore } from "@shared/config/appMode.store"
import { initSentry } from "@shared/lib/sentry"

const initApp = async () => {
    const cfg = getAppConfig()
    applyHead(cfg)
    initSentry()
    initThirdParties()

    const userMeta = await cloudfrontMetaInformation()
    const country = userMeta?.[CLOUD_FRONT_HEADERS.COUNTRY]
    useAppModeStore.setState({
        isWithoutCrypto: country?.toUpperCase() === BLOCKED_FOR_CRYPTO_COUNTRY,
    })
}

export default initApp
